import { Component, Output, EventEmitter, Input, ViewChild , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalDirective } from "../../directives/modal.directive";
import { AppSettings } from "../../appsettings";

@Component({
    selector: "confirmationcountrycontentdialogmodal",
    templateUrl: "./confirmationcountrycontentdialogmodal.component.html",
    standalone: true,
    imports: [CommonModule, ModalDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ConfirmationCountryContentModalComponent {
    @Output() onContentDeleteAccept = new EventEmitter();
    @Output() onContentDeleteDecline = new EventEmitter();
    @Input() ccConfirmationText: string = "";
    loaded: boolean = false;
    config: any = {};
    @ViewChild("confirmationcountrycontentdialogmodal") public confirmationcountrycontentdialogmodal: ModalDirective;

    constructor() {
        if (this.ccConfirmationText === "") {
            this.ccConfirmationText = AppSettings.pendingChangeText;
        }
    }

    /**
     * Emits the change to the caller and closes the modal
     */
    onContentDeleteClick(accept: boolean): void {
        if (accept) {
            this.onContentDeleteAccept.emit();
        } else {
            this.onContentDeleteDecline.emit();
        }
        this.confirmationcountrycontentdialogmodal.hide();
    }

    openModal(): void {
        this.confirmationcountrycontentdialogmodal.show();
    }
    closeModal(): void {
        this.confirmationcountrycontentdialogmodal.hide();
    }
}


